import React, { memo, useCallback, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/react-hooks'
import { toast } from 'react-toastify'

import { Loading } from 'components'
import { ConfirmUpdateEmail, StoreValue } from 'store'
import { EAppStateActionTypes } from 'models'

const UpdateProfileEmailView: React.FunctionComponent<any> = ({
	storeDispatch,
}) => {
	const {
		personID,
		token,
	}: {
		personID: string
		token: string
	} = useParams()
	const history = useHistory()
	const { t, i18n } = useTranslation()
	const updateGlobalStore = useCallback(
		({ updateEmail }) => {
			if (updateEmail) {
				storeDispatch({
					type: EAppStateActionTypes.updateUser,
					user: updateEmail,
				})
			}
		},
		[storeDispatch],
	)
	const uid = personID || null

	// Todo Kundan1023
	const [checkUpdateEmailTokenMutation] = useMutation(ConfirmUpdateEmail, {
		onCompleted(data) {
			updateGlobalStore(data)
			toast.success(t('Your email was successfully changed!'), {
				position: 'top-center',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			})
			history.push({
				pathname: `/${i18n.language}/people/${data.updateEmail.uid}/settings`,
			})

			window.localStorage.removeItem('cv30_email_update_token')
		},
		onError(error: any) {
			toast.error(t('Something went wrong. Please try again!'), {
				position: 'top-center',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			})
			history.push({
				pathname: `/`,
			})
		},
	})

	const checkUpdateEmailToken: any = useCallback(async () => {
		await checkUpdateEmailTokenMutation({
			variables: {
				token,
			},
		})
	}, [token, checkUpdateEmailTokenMutation])

	useEffect(() => {
		if (uid && token) {
			checkUpdateEmailToken()
		}
	}, [uid, token, checkUpdateEmailToken])

	return <Loading />
}

const UpdateProfileEmail = memo((props: any) => (
	<StoreValue keys={['storeDispatch']}>
		<UpdateProfileEmailView {...props} />
	</StoreValue>
))

export default memo(UpdateProfileEmail)
